module.exports = __webpack_public_path__ + "img/system11-mini.40aba246.png";